module.exports = __webpack_public_path__ + "static/media/Johannes_Ibach.c387fe05.jpeg";